<template>
  <div class="e-messages">
    <VuePerfectScrollbar
      class="e-messages__inner"
      :class="{ 'e-messages__inner--has-new-button': showNewDialogButton }"
    >
      <div v-if="isLoading" class="e-messages__note e-messages__note--loading">
        <Loading />
        <p>{{ $t('system.messages.loading') }}</p>
      </div>

      <template v-else>
        <MessageListItem
          v-for="message in items"
          :key="message.id"
          :data="message"
          :is-open="message.id === selectedItemId"
          :is-loading="message.id === loadingItemId"
          role="link"
          @click.native="toggleItem(message)"
          @keydown.native.enter="toggleItem(message)"
          tabindex="0"
        />

        <div class="e-messages__note">
          {{ noMessages }}
        </div>
      </template>
    </VuePerfectScrollbar>

    <div v-if="showNewDialogButton" class="e-messages__add">
      <el-button class="e-btn" type="secondary" @click="newDialog">
        <span class="e-btn__text">
          {{ $t('system.messages.new') }}
        </span>
        <IconPlus class="e-mobile-hidden" role="presentation" />
      </el-button>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import Loading from 'atoms/Loading/Loading'
import MessageListItem from 'molecules/MessageListItem/MessageListItem'

// Icons
import IconPlus from 'assets/icons/plus.svg'

export default {
  name: 'MessageList',
  components: {
    IconPlus,
    Loading,
    MessageListItem,
    VuePerfectScrollbar
  },
  props: {
    showNewDialogButton: {
      type: Boolean,
      default: true
    },
    items: {
      type: Array,
      default: () => [],
      required: true
    },
    selectedItemId: {
      type: String,
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    loadingItemId: {
      type: String,
      default: null
    }
  },
  data: () => ({
    selectedItem: null
  }),
  computed: {
    noMessages() {
      return this.items.length > 0
        ? this.$t('system.messages.noMore')
        : this.$t('system.messages.noItems')
    },
    hasUnfinishedDialogs() {
      return this.items.reduce(
        (acc, el) => acc || el.status !== 'finished',
        false
      )
    }
  },
  methods: {
    newDialog() {
      if (this.hasUnfinishedDialogs) {
        this.finishOldDialogsWarning()
        return
      }
      this.toggleItem(this.selectedItem)
      this.$router.push({
        name: 'newDialog'
      })
    },
    toggleItem(message) {
      if (this.selectedItem?.id == message?.id) {
        message = null
      }
      this.selectedItem = message
      this.$emit('select', this.selectedItem)
    },
    finishOldDialogsWarning() {
      this.$alert(
        window.landingTexts.finishOldDialogsPrompt,
        this.$t('system.attention'),
        {
          confirmButtonText: this.$t('system.ok'),
          type: 'warning',
          dangerouslyUseHTMLString: true
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '_assets/messagelist';
</style>
